import { appEvents } from "./app-events";
import { accounts, sessions, users } from "./auth";
import { blocks, pages } from "./blocks";
import { blogs } from "./blogs";
import { directors } from "./directors";
import { divisions } from "./divisions";
import { faqs } from "./faqs";
import { helpArticles } from "./help-articles";
import { levels } from "./levels";
import { matchRefTeams } from "./match-ref-teams";
import { matchRefs } from "./match-refs";
import { matchSets } from "./match-sets";
import { paymentIntents } from "./payment-intents";
import {
  invoices,
  memberships,
  refunds,
  tournamentRegistrations,
} from "./payments";
import { playerProfiles } from "./player-profiles";
import { playoffBracketTemplates } from "./playoff-bracket-templates";
import { playoffMatches } from "./playoff-matches";
import { poolMatches } from "./pool-matches";
import { poolTeams } from "./pool-teams";
import { pools } from "./pools";
import { rateLimiterFlexibleSchema } from "./rate-limits";
import { scoreEvents } from "./score-events";
import { settings } from "./settings";
import { teamPlayers } from "./team-players";
import { teams } from "./teams";
import { tournamentDirectors } from "./tournament-directors";
import { tournamentDivisionRequirements } from "./tournament-division-requirements";
import { tournamentDivisionTeams } from "./tournament-division-teams";
import { tournamentDivisions } from "./tournament-divisions";
import { tournamentGalleryPhotos } from "./tournament-gallery-photos";
import { tournamentInviteSources } from "./tournament-invite-sources";
import { tournamentInvites } from "./tournament-invites";
import { tournamentPlayerCheckIns } from "./tournament-player-check-ins";
import { tournaments } from "./tournaments";
import { legacyUsers, userProfiles } from "./user-profiles";
import { venueDirectors } from "./venue-directors";
import { venues } from "./venues";

export const tables = {
  appEvents,
  blocks,
  directors,
  divisions,
  levels,
  matchSets,
  matchRefTeams,
  matchRefs,
  pages,
  playerProfiles,
  playoffBracketTemplates,
  playoffMatches,
  poolMatches,
  pools,
  poolTeams,
  teamPlayers,
  teams,
  tournamentDirectors,
  tournamentDivisionRequirements,
  tournamentDivisions,
  tournamentDivisionTeams,
  tournamentGalleryPhotos,
  tournamentPlayerCheckIns,
  tournamentInviteSources,
  tournamentInvites,
  tournaments,
  users,
  accounts,
  venues,
  venueDirectors,
  rateLimiterFlexibleSchema,
  scoreEvents,
  faqs,
  helpArticles,
  blogs,
  invoices,
  memberships,
  paymentIntents,
  refunds,
  sessions,
  settings,
  tournamentRegistrations,
  legacyUsers,
  userProfiles,
};
